import FormModal from '../../components/FormModal';
import HideableSection from '../../components/HideableSection';
import { Button, Form, Modal } from '../../components';

import React from 'react';
import PropTypes from 'prop-types';

const GroupsGenerateForm = ({ formProps, values, onInputChange }) => (
  <Form {...formProps}>
    <HideableSection header="Group sizes">
      <Form.Group widths="equal">
        <Form.Input
          name="groupSizeA"
          value={values.groupSizeA}
          onChange={onInputChange}
          label="Group A"
          placeholder="Group A size"
          fluid
        />
        <Form.Input
          name="groupSizeB"
          value={values.groupSizeB}
          onChange={onInputChange}
          label="Group B"
          placeholder="Group B size"
          fluid
        />
        <Form.Input
          name="groupSizeOther"
          value={values.groupSizeOther}
          onChange={onInputChange}
          label="Other"
          placeholder="Other group size"
          fluid
        />
      </Form.Group>
    </HideableSection>
  </Form>
);

const GroupsGenerateModal = ({ id, trigger, meta, onGenerate }) => {
  const defaultValues = {
    groupSizeA: 18,
    groupSizeB: 18,
    groupSizeOther: 18,
  };

  const Actions = ({ formProps, modal }) => (
    <Modal.Actions>
      <Button form={formProps.id} floated="right" positive>
        Generate
      </Button>
      <Button onClick={modal.onCancel}>Cancel</Button>
      <Button onClick={modal.onReset} floated="left">
        Reset
      </Button>
    </Modal.Actions>
  );

  const onSubmit = values => onGenerate(values);

  return (
    <FormModal
      id={`${id}--form`}
      trigger={trigger}
      header="Generate groups"
      Form={GroupsGenerateForm}
      Actions={Actions}
      defaultValues={defaultValues}
      meta={meta}
      onSubmit={onSubmit}
    />
  );
};

GroupsGenerateModal.propTypes = {
  id: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  meta: PropTypes.object.isRequired,
  onGenerate: PropTypes.func.isRequired,
};

export default GroupsGenerateModal;



// WEBPACK FOOTER //
// ./src/pages/Schedule/GroupsGenerateModal.js